import silent_sound_src from '../resources/sound/silence.mp3';

export const playSilentNotifications = () => {
    const alertSound = new Audio(silent_sound_src);
    alertSound.play();
}